if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('btn--loading');
      var productUrl = opener.getAttribute('data-product-url');
      if (productUrl.indexOf("?") > -1) {
        var productUrlSplit = productUrl.split('?');
        productUrl = productUrlSplit[0];
      }
      fetch(`${productUrl}?section_id=product-quick-buy`)
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('div[id^="product-quick-buy"]');
          
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) window.ProductModel.loadShopifyXR();
          this.classList.remove('hide-popup');
          $(document).find("body").attr("active-popup", 'quick-add-modal');
          $(document).find('.theme-popup-overlay').removeClass('hidden-overlay');
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('btn--loading');
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;
      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }
  });
  $(document).on('change','.js-option-select',function(){
    var closeForm = $(this).closest('product-form');
    var closeModel = $(this).closest('quick-add-modal');
    var variantContainer = closeForm.find('.variant--selection-options');
    var currentProductUrl = variantContainer.attr('data-url');
    var sectionId = variantContainer.attr('data-section');

    var addButton = closeForm.find('.quick-add__submit[name="add"]');
    addButton.prop('disabled', true);

    var selectedValueIds = [];
    var newProductUrl = null;

    closeForm.find('.js-option-select').each(function(){
      var selectedOption = $(this).find('option:selected');
      var optionValueId = selectedOption.attr('data-option-value-id');
      var optionProductUrl = selectedOption.attr('data-product-url');

      if (optionValueId) {
        selectedValueIds.push(optionValueId);
      }

      if (optionProductUrl && !newProductUrl) {
        newProductUrl = optionProductUrl;
      }
    });

    var productUrl = newProductUrl || currentProductUrl;
    var shouldSwapProduct = currentProductUrl !== productUrl;

    var params = new URLSearchParams({
      section_id: sectionId,
      option_values: selectedValueIds.join(',')
    });

    fetch(`${productUrl}?${params.toString()}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceVariantContainer = html.querySelector('.variant--selection-options');

        if (!sourceVariantContainer) {
          console.warn('Variant container not found in response');
          return;
        }

        var variantId = html.querySelector('input[name="id"]').value;
        var link = variantId ? productUrl + '?variant='+ variantId : productUrl;
        closeModel.find('.product--title').attr('href', link);

        if (shouldSwapProduct) {
          variantContainer.attr('data-url', productUrl);
          var productTitle = html.querySelector('.product--title').textContent.trim();
          closeModel.find('.product--title').text(productTitle);
        }

        updateQuickBuyOptions(closeForm, sourceVariantContainer);
        updateQuickBuyPrice(closeModel, html);
        updateQuickBuyImage(closeModel, html);
        updateQuickBuyVariantInput(closeForm, html);
        updateQuickBuyButton(closeForm, html);
      })
      .catch((error) => {
        console.error('Error fetching variant:', error);
        addButton.prop('disabled', false);
      });
  });

  function updateQuickBuyOptions(form, sourceContainer) {
    var currentSelects = form.find('.js-option-select');
    var sourceSelects = $(sourceContainer).find('.js-option-select');

    sourceSelects.each(function(index) {
      var sourceOptions = $(this).find('option');
      var currentSelect = $(currentSelects[index]);
      var currentOptions = currentSelect.find('option');

      sourceOptions.each(function(optIndex) {
        var sourceOption = $(this);
        var currentOption = $(currentOptions[optIndex]);

        if (currentOption.length) {
          currentOption.text(sourceOption.text());

          if (sourceOption.hasClass('disabled')) {
            currentOption.addClass('disabled');
          } else {
            currentOption.removeClass('disabled');
          }
        }
      });
    });
  }

  function updateQuickBuyPrice(modal, html) {
    var sourcePrice = html.querySelector(`.price`);
    var currentPrice = modal.find('.price');

    if (sourcePrice && currentPrice.length) {
      currentPrice.html(sourcePrice.innerHTML);
    }
  }

  function updateQuickBuyImage(modal, html) {
    var sourceImage = html.querySelector('.quickBuy--product-image');
    var currentImage = modal.find('.quickBuy--product-image');

    if (sourceImage && currentImage.length) {
      currentImage.attr('src', sourceImage.src);
      currentImage.attr('alt', sourceImage.alt);
    } else {
      if (!sourceImage) console.warn('Source image not found in server response');
      if (!currentImage.length) console.warn('Current image not found in modal');
    }
  }

  function updateQuickBuyButton(form, html) {
    var sourceButton = html.querySelector('.quick-add__submit[name="add"]');
    var currentButton = form.find('.quick-add__submit[name="add"]');

    if (!sourceButton || !currentButton.length) return;

    if (sourceButton.hasAttribute('disabled')) {
      currentButton.prop('disabled', true);
      currentButton.find('.spn--add').addClass('hidden');
      currentButton.find('.sold-out-message').removeClass('hidden');
    } else {
      currentButton.prop('disabled', false).removeAttr('aria-disabled');
      currentButton.find('.spn--add').removeClass('hidden');
      currentButton.find('.sold-out-message').addClass('hidden');
    }
  }

  function updateQuickBuyVariantInput(form, html) {
    var sourceInput = html.querySelector('input[name="id"]');
    var currentInput = form.find('input[name="id"]');

    if (!currentInput.length) return;

    if (sourceInput) {
      currentInput.val(sourceInput.value);

      if (sourceInput.hasAttribute('disabled')) {
        currentInput.prop('disabled', true);
      } else {
        currentInput.prop('disabled', false);
      }
    } else {
      console.warn('Source input not found in server response');
    }
  }
}